// import { Calendar } from 'antd';
import React, { useState, useEffect } from 'react'
import { DatePicker, Space, message } from 'antd';
import { setEndDate, setStartDate, barGraphPlotFunction } from 'actions/adminCare';
import { connect } from 'react-redux';
import { setEndDateLib, setStartDateLib } from 'actions/digitalLibrary';
import moment from 'moment';
import { Notification } from 'services';


const { RangePicker } = DatePicker;


const CalenderPopup = ({ setStartDate, setStartDateLib, setEndDateLib, setEndDate, barGraphPlotFunction, togglePageLoader, digitalLib, startDate, endDate, isMonthOrWeek }) => {
  const [dates, setDates] = useState(null);
  const currentWeekStart = moment().startOf("week");
  const currentWeekEnd = moment().endOf("week");

  useEffect(() => {
    if (
      isMonthOrWeek === "week" &&
      !startDate &&
      !endDate
    ) {
      setStartDate(moment().startOf("week").format("YYYY-MM-DD"));
      setEndDate(moment().endOf("week").format("YYYY-MM-DD"));
    }
  }, [isMonthOrWeek]);

  function onChange(dates, dateStrings) {
    if (!dates || !dates[0] || !dates[1]) {
      const start = moment().startOf("week");
      const end = moment().endOf("week");

      setStartDate(start.format("YYYY-MM-DD"));
      setEndDate(end.format("YYYY-MM-DD"));

      togglePageLoader(true);
      barGraphPlotFunction(() => togglePageLoader(false));

      return;
    }
    if (dates && dates[0] && dates[1]) {
      const diff = dates[1].diff(dates[0], 'days') + 1;
      if (isMonthOrWeek === 'week' && diff > 7) {
        Notification.error("Please select a date range within 7 days.");
        return;
      }
    }
    if (digitalLib == true) {
      setStartDateLib(dates[0].format("YYYY-MM-DD"));
      setEndDateLib(dates[1].format("YYYY-MM-DD"));


    } else {
      togglePageLoader(true)
      setStartDate(dates[0].format("YYYY-MM-DD"));
      setEndDate(dates[1].format("YYYY-MM-DD"));
      barGraphPlotFunction(() => togglePageLoader(false))
    }
  }

  const disabledDate = (current) => {
    if (isMonthOrWeek === 'week') {
      if (!dates || dates.length === 0) {
        return false;
      }
      const selectedDate = dates[0] || dates[1];
      if (!selectedDate) {
        return false;
      }
      const tooLate = current.diff(selectedDate, 'days') > 6;
      const tooEarly = selectedDate.diff(current, 'days') > 6;
      return tooLate || tooEarly;
    }
    return false;
  };

  const onCalendarChange = (val) => {
    setDates(val);
  };

  const onOpenChange = (open) => {
    if (open) {
      setDates(null);
    }
  };

  return (

    <div className="rangePicker" style={{ width: '230px' }} >
      <Space direction="vertical" mode={'month'} size={12} style={{ width: '230px' }}>

        <RangePicker style={{ width: "100%" }} format="DD-MM-YYYY" value={[startDate ? moment(startDate, "YYYY-MM-DD") : currentWeekStart, endDate ? moment(endDate, "YYYY-MM-DD") : currentWeekEnd]} dropdownClassName={'rangePickerB'} placeholder={['Start Date', 'End Date']} onChange={onChange} onCalendarChange={onCalendarChange} onOpenChange={onOpenChange} disabledDate={disabledDate} renderExtraFooter={() => 'extra footer'} />

      </Space>

    </div>
  )
}


const mapStateToProps = (state) => {

  const { user,
    startDate,
    endDate } = state.adminCare;
  return {
    startDate,
    endDate
  };
};
const mapDispatchToProps = dispatch => ({

  setStartDate: (m) => dispatch(setStartDate(m)),
  setEndDate: (m) => dispatch(setEndDate(m)),
  barGraphPlotFunction: (callback) => dispatch(barGraphPlotFunction(callback)),
  setEndDateLib: (endDate) => dispatch(setEndDateLib(endDate)),
  setStartDateLib: (startDate) => dispatch(setStartDateLib(startDate)),

});


export default connect(mapStateToProps, mapDispatchToProps)(CalenderPopup);



